import { apiClient } from "../../../services/apiClient";
import { API_ENDPOINTS } from "../../../config/apiEndpoints";

export const eventsService = {
  getCompanyCalendarEvents: async (year, month) => {
    return apiClient.post(API_ENDPOINTS.EVENTS.COMPANY_CALENDAR, { year, month });
  },
};
